import { render, staticRenderFns } from "./imports_select_submissions.vue?vue&type=template&id=b48f2a62&scoped=true&"
import script from "./imports_select_submissions.vue?vue&type=script&lang=js&"
export * from "./imports_select_submissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48f2a62",
  null
  
)

export default component.exports